<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2021-01-12 09:58:42
 * @LastEditors: mrh
 * @LastEditTime: 2021-01-28 14:45:35
-->
<template>
  <div class="content">
    <!-- <header v-if="isWX != 0">
      <i class="iconfont icon-home_location_icon_l" @click="returnBack"></i>
      <p>悦卖用户协议</p>
    </header> -->
    <!-- <h5-header v-if="isWX != 0" :header-msg="headerMsg"></h5-header> -->
    <div  v-html="content" class='cont'></div>
  </div>
</template>

<script>
import { getActivityRuleContent } from "@/api/picker/index.js";
export default {
  data() {
    return {
    //   isWX: "1",
    //   headerMsg: {
    //     title: "悦卖用户协议",
    //     url: "/joinup",
    //   },
      content: "",
    };
  },
  mounted() {
    // this.isWX = this.GetQueryString("wx");
    this.getContent();
  },
  methods: {
    getContent() {
      getActivityRuleContent({
        type: "17", // 教程类型: 2.选菜师教程，3.城市合伙人教程，4.无码商品教程，5.选菜师协议，6.城市合伙人协议，7选菜师攻略教程，8.店长攻略，9爆款活动规则,10拼单活动规则，11：打印说明文档，12 店长协议 13悦买用户协议，14悦卖用户协议 15菜老板协议  16 悦买隐私政策,17 悦卖隐私政策,18 选菜师隐私政策,19 菜老板隐私政策,
      }).then((res) => {
        // console.log(res);
        let result = res.content.content
          .replace(/&#x3c;/g, "<")
          .replace(/&#x3e;/g, ">")
          .replace(/&#x22;/g, '"');
        // let result2 = result1.replace(/&#x3e;/g,'>')
        this.content = result;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: auto;
  overflow: auto;
  width: auto;
  padding: 0 10px;
  img {
    width: 371px;
  }
  .cont {
    height: fit-content;
    margin-top: 10px;
    text-align: left;
  }
  .mt {
    height: fit-content;
    margin-top: 0;
  }
}
</style>
